import { Settings } from "@mui/icons-material";
import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import loader from "../../../assets/img/loader.gif";
import BatchProcess from "../pages/orders/batch-process";
import DisputeList from "../pages/orders/dispute_list";
import AddProductWithVariant from "../pages/products/addProduct/AddProductWithVariant";
import StoreDetails from "../pages/stores/store-details";
import UserDetails from "../pages/stores/userDetails";
import UserList from "../pages/referrals/userList";
const AdminPrivateOutlet = lazy(() =>
  import("../components/AdminPrivateOutlet")
);
const AffiliatePrograms = lazy(() => import("../pages/affiliatePrograms"));
const BulkPurchase = lazy(() => import("../pages/bulkPurchase"));
const Dashboard = lazy(() => import("../pages/dashboard"));
const Products = lazy(() => import("../pages/products"));
const ModifyShopifyProduct = lazy(() =>
  import("../pages/products/addProduct/ModifyShopifyProduct")
);
const ProductDetails = lazy(() =>
  import("../../admin/pages/products/productDetails")
);
const SourcingRequest = lazy(() => import("../pages/sourcing-request"));
const AddCarrier = lazy(() => import("../pages/shipping/addCarrier"));
const Shipping = lazy(() => import("../pages/shipping"));
const Notification = lazy(() => import("../pages/notification"));
const Orders = lazy(() => import("../pages/orders"));
const OrderTracking = lazy(() => import("../pages/orders/order_tracking"));
const ReturnedOverseas = lazy(() => import("../pages/orders/returned-overseas"));
const Stores = lazy(() => import("../pages/stores"));
const Reports = lazy(() => import("../pages/reports"));
const Referrals = lazy(() => import("../pages/referrals"));
const TrackingPages = lazy(() => import("../pages/tracking-pages"));
const Payments = lazy(() => import("../pages/payments"));
const MailTrackers = lazy(() => import("../pages/mail-trackers"));
const NewSourcingRequest = lazy(() =>
  import("../pages/sourcingList/newSourcingRequest")
);
const RequotationSourcingList = lazy(() =>
  import("../pages/sourcingList/requotationSourcingList")
);

export default function AdminRouter() {
  return (
    <Suspense
      fallback={
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:"#fff"
          }}
        >
          <img
            src={loader}
            alt="loader"
            style={{ width: "200px", height: "200px", objectFit: "contain" }}
          />
        </div>
      }
    >
      <Routes>
        <Route path="/admin/*" element={<AdminPrivateOutlet />}>
          <Route path="" element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<ProductDetails />} />
          <Route
            path="products/add-product"
            element={<AddProductWithVariant />}
          />
          <Route
            path="products/edit-product/:id"
            element={<ModifyShopifyProduct />}
          />
          <Route path="shipping" element={<Shipping />} />
          <Route
            path="shipping/add-shipping-formula"
            element={<AddCarrier />}
          />
          <Route
            path="shipping/edit-shipping-formula/:id"
            element={<AddCarrier />}
          />
          <Route
            path="products/sourcing-request"
            element={<SourcingRequest />}
          />
          {/* <Route path="sourcing-list/product/:id" element={<ProductPage />} /> */}
          <Route
            path="sourcing-list/requotation"
            element={<RequotationSourcingList />}
          />
          <Route
            path="sourcing-list/new-sourcing-request"
            element={<NewSourcingRequest />}
          />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/batch-process" element={<BatchProcess />} />
          <Route path="orders/order-tracking" element={<OrderTracking />} />
          <Route path="orders/returned-to-overseas-warehouse" element={<ReturnedOverseas />} />
          <Route path="orders/dispute-list" element={<DisputeList />} />
          <Route path="bulk-purchase" element={<BulkPurchase />} />
          <Route path="payments" element={<Payments />} />
          <Route path="mail-trackers" element={<MailTrackers />} />
          <Route path="users" element={<Stores />} />
          <Route path="reports" element={<Reports />} />
          <Route path="referrals" element={<Referrals />} />
          <Route path="tracking-pages" element={<TrackingPages />} />
          <Route path="referrals/:referralId/users" element={<UserList />} />
          <Route path="users/user-details/:id" element={<UserDetails />} />
          <Route
            path="users/user-details/:id/store-details/:id"
            element={<StoreDetails />}
          />
          <Route path="notification" element={<Notification />} />
          <Route path="affiliate-program" element={<AffiliatePrograms />} />
          <Route path="setting" element={<Settings />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
